import React from 'react'

export const CarouselItem = ({ children, extraContent = null }) => {
  return (
    <div>
      <div className="carousel-container">
        <div className="container">
          <div className="row">{children}</div>
          {extraContent}
        </div>
      </div>
    </div>
  )
}
